import { AffiliateExportRow } from '@telespot/domain';

/**
 * CSV header for the organization members export. Kept identical to the
 * `run-export-organization-affiliates` maintenance script so both produce the
 * same file.
 */
export const ORGANIZATION_AFFILIATES_CSV_HEADER = [
  'ID Organización',
  'Nombre Organización',
  'ID User',
  'username User',
  'email User',
  'emailVerified User',
];

/**
 * Escapes a value for CSV: wraps it in quotes when it contains a comma, quote or
 * line break, doubling any inner quotes.
 */
export function escapeCsvValue(value: string | boolean | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * Builds the CSV body (header + one row per affiliate) for an organization's
 * members export. The BOM is added at download time, not here.
 */
export function buildOrganizationAffiliatesCsv(rows: AffiliateExportRow[]): string {
  const header = ORGANIZATION_AFFILIATES_CSV_HEADER.join(',');

  const dataRows = rows.map((row) =>
    [
      escapeCsvValue(row.organizationId),
      escapeCsvValue(row.organizationName),
      escapeCsvValue(row.userId),
      escapeCsvValue(row.username),
      escapeCsvValue(row.email),
      escapeCsvValue(row.emailVerified),
    ].join(',')
  );

  return dataRows.length > 0 ? `${header}\n${dataRows.join('\n')}` : header;
}
